import React from 'react'
import styled from 'styled-components'
import HeldToCompareIcon from '../../../../components/icons/DriveTableIcon/HeldToCompare.js'
import HoldBlackIcon from '../../../../components/icons/DriveTableIcon/HoldBlack'
import HoldYellowIcon from '../../../../components/icons/DriveTableIcon/HoldYellow'
import MovedToNextRoundIcon from '../../../../components/icons/DriveTableIcon/MovedToNextRound.js'
import RejectIcon from '../../../../components/icons/DriveTableIcon/Reject'
import RescheduleIcon from '../../../../components/icons/DriveTableIcon/Reschedule'
import ShortlistIcon from '../../../../components/icons/DriveTableIcon/Shortlist'
import ToBeScheduledIcon from '../../../../components/icons/DriveTableIcon/ToBeScheduled.js'

const DriveStatus = ({ status }) => {
  const StyledContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
  `
  const StyledIcon = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
  `
  let tagMessage
  let icon
  if (status == 'SCHEDULED') {
    tagMessage = 'Scheduled'
  } else if (status == 'TO_BE_SCHEDULED') {
    tagMessage = 'To be scheduled'
    icon = <ToBeScheduledIcon />
  } else if (status == 'INVITED') {
    tagMessage = 'Invited'
  } else if (status == 'SHORTLISTED') {
    tagMessage = 'Shortlisted'
    icon = <ShortlistIcon />
  } else if (status == 'INTENT') {
    tagMessage = 'Intent To Offer'
    icon = <ShortlistIcon />
  } else if (status == 'COMPLETED') {
    tagMessage = 'Completed'
  } else if (status == 'QUALIFIED') {
    tagMessage = 'Qualified'
  } else if (status == 'HOLD_TO_COMPARE') {
    tagMessage = 'Hold to compare'
    icon = <HoldYellowIcon />
  } else if (status == 'REJECTED') {
    tagMessage = 'Rejected'
    icon = <RejectIcon />
  } else if (status == 'ABSENT') {
    tagMessage = 'Absent'
    icon = <HoldBlackIcon />
  } else if (status == 'RESCHEDULE_REQUESTED') {
    tagMessage = 'Req.Reschedule'
  } else if (status == 'STATUS_CONFLICT') {
    tagMessage = 'Status Conflict'
  } else if (status == 'HELD_TO_COMPARE') {
    tagMessage = 'Held to compare'
    icon = <HeldToCompareIcon />
  } else if (status == 'MOVE_TO_NEXT_ROUND') {
    tagMessage = 'Move to next round'
    icon = <MovedToNextRoundIcon />
  } else if (status == 'TO_BE_UPDATED') {
    tagMessage = 'To be updated'
  } else if (status == 'RESCHEDULED') {
    tagMessage = 'Rescheduled'
    icon = <RescheduleIcon />
  } else if (status == 'RESCHEDULE') {
    tagMessage = 'Reschedule'
  } else if (status == 'SELECTED') {
    tagMessage = 'Shortlisted'
    icon = <ShortlistIcon />
  } else if (status == 'REJECT') {
    tagMessage = 'Offer Declined'
    icon = <RejectIcon />
  } else if (status == 'RELEASED') {
    tagMessage = 'Offer letter released'
    icon = <ShortlistIcon />
  } else if (status == 'ACCEPTED') {
    tagMessage = 'Accepted'
    icon = <ShortlistIcon />
  } else if (status === 'NOT_RELEASED') {
    tagMessage = 'Not Released'
  } else if (status == 'SKIPPED') {
    tagMessage = 'Skipped' 
  } else if (status == 'JOINED') {
    tagMessage = 'Joined'
    icon = <ShortlistIcon />
  } else if (status == 'LEFTED') {
    tagMessage = 'left'
    icon = <RejectIcon />
  } else {
    tagMessage = 'Yet to Update'
  }
  return (
    <StyledContainer
      style={{
        color: tagMessage == 'Status Conflict' ? 'red' : '',
        display: 'flex',
      }}
    >
      <StyledIcon>{icon}</StyledIcon>
      <div style={{ fontSize: 'smaller' }}>{tagMessage}</div>
    </StyledContainer>
  )
}

export default DriveStatus
